import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=7b85b538&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=7b85b538&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85b538",
  null
  
)

export default component.exports